// TODO: Update status numbers
export enum ClaimStatus {
    CLAIM_RECEIVED = 'claimReceived',
    CLOSED = 'closed',
    DENIED = 'denied',
    DOCUMENT_PENDING = 'docsPending',
    DRAFT = 'draft',
    DRAFT_DISCARDED = 'draftDiscarded',
    INVALID_CARRIER = 'carrierError',
    INVALID_INSURED_VALUE = 'insuredValueError',
    INVALID_SHIP_DATE = 'shipDateError',
    INVESTIGATION_PENDING = 'invPending',
    MISSING_SHIPMENT = 'missingShipment',
    NEW = 'new',
    PAYMENT_PAID = 'paid',
    PROCESSING = 'processing',
    SUBMIT_PAYMENT = 'submitPayment',
    SUBMIT_ERROR = 'submitError',
    SUITABLE_FOR_CLAIM = 'suitable',
    WITHDRAWN = 'withdraw',
}
